import * as types from '../actions/action-types.js';

const initial = {
  items: [],
  loading: false,
  error: false,
  minimumSpend: {
    minimum_spend: null,
    spend: null,
    shortfall: null,
    percent: null,
    vendor_id: null,
    loading: false,
    error: false,
  },
  productLists: {},
};

export default function equipment(state = initial, action) {
  switch (action.type) {
    case types.GET_EQUIPMENT:
      return { ...state, loading: true, error: false };
    case types.SUCCESS_GET_EQUIPMENT:
      return { ...state, items: action.data, loading: false, error: false };
    case types.ERROR_GET_EQUIPMENT:
      return { ...state, items: [], loading: false, error: true };
    case types.GET_EQUIPMENT_MINIMUM_SPEND:
      return {
        ...state,
        minimumSpend: { ...state.minimumSpend, loading: true, error: false },
      };
    case types.SUCCESS_GET_EQUIPMENT_MINIMUM_SPEND:
      return {
        ...state,
        minimumSpend: { ...action.data, loading: false, error: false },
      };
    case types.ERROR_GET_EQUIPMENT_MINIMUM_SPEND:
      return {
        ...state,
        minimumSpend: { ...initial.minimumSpend, error: true },
      };
    case types.GET_EQUIPMENT_PRODUCT_LIST:
      return {
        ...state,
        productLists: {
          ...state.productLists,
          [action.data.equipment_id]: { loading: true, products: [], list_name: '' },
        },
      };
    case types.SUCCESS_GET_EQUIPMENT_PRODUCT_LIST:
      return {
        ...state,
        productLists: {
          ...state.productLists,
          [action.data.equipment_id]: {
            loading: false,
            products: action.data.products || [],
            list_name: action.data.list_name || '',
          },
        },
      };
    case types.ERROR_GET_EQUIPMENT_PRODUCT_LIST:
      return {
        ...state,
        productLists: {
          ...state.productLists,
          [action.data.equipment_id]: { loading: false, products: [], list_name: '' },
        },
      };
    case types.SWITCH_LOCATION:
      return { ...initial };
    default:
      return state;
  }
}
